import comp from "./ChildModal";
export default comp;
